<script setup lang="ts">
import type { SocialEmbed } from '~kui/utils/socialEmbed';

import { socialEmbedFrameVariants } from '~kui/utils/richTextMedia';
import { socialEmbedProviderLabel, socialEmbedSrc } from '~kui/utils/socialEmbed';
import { useI18n } from 'vue-i18n';

interface Props {
  embed: SocialEmbed;
}

const props = defineProps<Props>();

const { t } = useI18n();

const title = computed(() => t('kui.richTextEditor.embed.title', { provider: socialEmbedProviderLabel(props.embed.provider) }));
</script>

<template>
  <div
    class="min-w-64 max-w-sm flex-1"
    :data-provider="embed.provider"
    data-testid="rte-renderer-embed"
  >
    <iframe
      :src="socialEmbedSrc(embed)"
      :title="title"
      class="border-0"
      :class="socialEmbedFrameVariants({ provider: embed.provider })"
      loading="lazy"
      allow="encrypted-media; fullscreen; picture-in-picture"
      allowfullscreen
      sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-presentation"
    />
  </div>
</template>
